document.addEventListener("DOMContentLoaded", function () {
  let accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach(function (header) {
    const button = header.querySelector(".accordion-label");
    const panel = header.nextElementSibling;

    header.addEventListener("click", function () {
      toggleAccordion(button, panel);
    });

    function toggleAccordion(button, panel) {
      const expanded = panel.classList.contains("active");
      panel.classList.toggle("active");
      header.classList.toggle("section-open");
      button.setAttribute("aria-expanded", !expanded);
    }
  });
});
